<template>
  <div>
      <div :class="['circle', backgroundClassColor]">
        <span class="initials">{{initials}}</span>
      </div>
  </div>
    
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: {
    initials: {
      type: String,
      required: true,
      default: '?'
    },
    backgroundClassColor: {
      type: String,
      required: false,
      default: 'bg-info'
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  },
  filters: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="sass" scoped>

  $avatar-size: 40px 
  .circle 
    border-radius: 50%
    height: $avatar-size
    text-align: center
    width: $avatar-size

  .initials 
    font-weight: normal
    font-size: calc(#{$avatar-size} / 2)
    line-height: 1
    position: relative 
    top: calc(#{$avatar-size} / 4)
    color: #FFFFFF 
</style>


// WEBPACK FOOTER //
// src/components/LetterAvatar.vue